import React, { useState } from 'react';

import { Skeleton } from 'components/ui/skeleton';
import { useNavigationPaths } from 'hooks/useNavigationPaths';

export interface DesktopNavProps {
  logoUrl: string | null | undefined;
  brandName: string;
}

function getBrandInitials(name: string): string {
  return name
    .split(' ')
    .slice(0, 2)
    .map((word) => word[0])
    .join('')
    .toUpperCase();
}

export function DesktopNav({ logoUrl, brandName }: DesktopNavProps) {
  const { homePath } = useNavigationPaths();
  const [imgError, setImgError] = useState(false);

  const showFallback = !logoUrl || imgError;
  return (
    <div className="flex items-center">
      <a href={homePath}>
        {showFallback ? (
          <div className="flex h-10 w-10 items-center justify-center rounded-full bg-gray-200 text-sm font-semibold text-gray-600">
            {getBrandInitials(brandName)}
          </div>
        ) : (
          <img
            src={logoUrl}
            alt="brand logo"
            className="h-14"
            onError={() => setImgError(true)}
          />
        )}
      </a>
    </div>
  );
}

DesktopNav.Skeleton = function DesktopNavSkeleton() {
  return (
    <div className="flex items-center">
      <Skeleton className="h-10 w-[150px]" />
    </div>
  );
};
